(function() {
  'use strict';
  angular.module('common')
  .directive('subscriberId', ['cursorPosition', function(cursorPosition) {
    var excludedCharacters = /[^a-zA-Z0-9]+/g;
    var validCharacters = /^[A-Z0-9]+$/;
    var maxLength = 12;
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function($scope, element, attrs, ngModelController) {
        ngModelController.$parsers.push(function(val) {
          if (!val) {
            return '';
          }
          val = val.replace(excludedCharacters,'');
          if (!val) {
            ngModelController.$setViewValue('');
            ngModelController.$render();
            return '';
          }
          var cursorPos = cursorPosition(element[0]);
          if (val.length > maxLength) {
            val = val.substring(0, maxLength);
          }
          val = val.toUpperCase();
          ngModelController.$setViewValue(val);
          ngModelController.$render();
          element[0].setSelectionRange(cursorPos,cursorPos);
          return val;
        });
        ngModelController.$validators.subscriberIdLength = function(val) {
          if (!val) {
            return true;
          }
          return val.length >= 9;
        };
        ngModelController.$validators.validSubscriberId = function(val) {
          if (!val) {
            return true;
          }
          return validCharacters.test(val);
        };
      }
    };
  }]).filter('subscriberId', [function() {
    return function(val) {
      return _.padStart(val,12,0).substring(3,12);
    };
  }]);

})();
